import { Box, Image } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import fireworks from '../images/fireworks.png';
import { isExpiredNewYear } from '../utils';

/**
 * @description 煙火圖示元件
 * @returns {JSX.Element}
 */
const Fireworks = ({ sx }) => {
  const currentCurrency = useSelector((state) => state.isWalletCurrency);

  // 若已過新年裝飾結束日期，則不顯示煙火元件
  if (isExpiredNewYear()) return null;

  // 若當前幣別為馬來幣，則不顯示煙火元件
  if (currentCurrency === 'MYR') return null;

  return (
    <Box
      display={{ base: 'none', lg: 'block' }}
      pointerEvents={'none'}
      position="fixed"
      sx={sx}
    >
      <Image src={fireworks} alt="Fireworks" />
    </Box>
  );
};
export default Fireworks;
